import {
  useMutation,
  useQueryClient,
  useSuspenseInfiniteQuery,
} from "@tanstack/react-query";
import { createInquiry, getInquiries } from "../network/api/inquiry.api";
import { CreateInquiry } from "../network/api/types.api";

export const useInquiries = (filtersObject: GetInquiriesPayload) =>
  useSuspenseInfiniteQuery({
    queryKey: ["inquiries", filtersObject],
    queryFn: ({ pageParam }) => {
      return getInquiries({
        page: pageParam,
        limit: filtersObject?.limit ?? 5,
      });
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      const loaded = allPages.flatMap((p) => p.inquiries).length;
      return loaded < lastPage.total ? allPages.length + 1 : undefined;
    },
    meta: {
      errorMessage: "Failed to load inquries. Please try again.",
    },
  });

export const useCreateInquiry = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: CreateInquiry) => createInquiry(params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["inquiries"],
      });
    },
  });
};
